import { zExt } from "@redotech/redo-model/common/zod-util";
import { z } from "zod/v4";

export enum OrderSearchErrors {
  NO_EMAIL = "NO_EMAIL",
  NEW_AUTH_ONLY = "NEW_AUTH_ONLY",
  ORDERLESS_UNSUPPORTED = "ORDERLESS_UNSUPPORTED",
  INVALID_SEARCH = "INVALID_SEARCH",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

export enum TimeFrame {
  SIX_MONTHS = "6m",
  ONE_YEAR = "1y",
  TWO_YEARS = "2y",
}

const DisplayLineItemSchema = z.object({
  id: z.union([z.string(), z.number()]),
  title: z.string().nullish(),
  name: z.string().nullish(),
  variant_title: z.string().nullish(),
  sku: z.string().nullish(),
  quantity: z.number().default(1).optional(),
  price: z.string().default("NaN").optional(),
  image: z
    .object({ src: z.string().nullish(), alt: z.string().nullish() })
    .nullish(),
  price_set: z
    .object({
      presentment_money: z
        .object({ currency_code: z.string().nullish() })
        .nullish(),
    })
    .nullish(),
});
export const DisplayLineItem: z.ZodType<DisplayLineItem> =
  DisplayLineItemSchema;
export interface DisplayLineItem
  extends z.infer<typeof DisplayLineItemSchema> {}

// Create a DisplayOrder schema that only includes fields needed for the orders UI
const DisplayOrderSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.union([z.string(), z.date()]),
  shopify: z.object({
    id: z.union([z.string(), z.number()]),
    name: z.string().default("unknown").optional(),
    email: z.string().nullish(),
    source_name: z.string().nullish(),
    fulfillment_status: z.string().nullish(),
    line_items: z.array(DisplayLineItemSchema),
  }),
});

export const DisplayOrder: z.ZodType<DisplayOrder> = DisplayOrderSchema;
export interface DisplayOrder extends z.infer<typeof DisplayOrderSchema> {}

export const getOrdersFromSearch = {
  input: z.object({
    searchTerm: z.string().nullish(),
    timeFrame: z
      .enum([TimeFrame.SIX_MONTHS, TimeFrame.ONE_YEAR, TimeFrame.TWO_YEARS])
      .optional()
      .default(TimeFrame.SIX_MONTHS),
  }),
  output: z.object({
    orders: z.array(DisplayOrderSchema),
    totalOrders: z.number(),
  }),
};
